import React, { useState, useEffect, useRef, useReducer } from 'react'
import { Link } from 'react-router-dom'

import { useGlobalState } from '@/state'
import useQuery from '@/hooks/useQuery'

import Loading from '@/shared/Loading'
import EventRow from '@/shared/EventRow'

const SECTION_CLASS = 'bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xl shadow-slate-900/[0.07] p-6 sm:p-8'
const H2_CLASS = 'text-xl sm:text-2xl font-bold text-slate-900 dark:text-slate-100'

export default function EventIndex(props) {
  const [ currentUser ] = useGlobalState('currentUser')
  const { getRequest } = useQuery()
  const isComponentMounted = useRef(false)

  const [state, setState] = useReducer(
    (state, newState) => ({...state, ...newState}),
    { events: [], attendingEventIds: [] }
  )
  const { events, attendingEventIds } = state

  useEffect(() => {
    getRequest(`/api/v1/events`, {}, (err, jsonData) => {
      if (err) { /* handled in hook */ return }
      setState({
        events: jsonData.events,
        attendingEventIds: jsonData.attendingEventIds
      })
    })
    isComponentMounted.current = true
  }, [])

  if (!isComponentMounted.current) { return <Loading /> }

  return <div className='py-8 space-y-8'>
    <section className={SECTION_CLASS}>
      <h2 className={H2_CLASS}>Upcoming events</h2>

      {events.length === 0 ? (
        <div className="text-center py-10">
          <h3 className="text-base font-bold text-slate-900 dark:text-slate-100">No upcoming events</h3>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-400 max-w-md mx-auto">
            If you're part of an upcoming semester, your events will appear one week before the course begins.
          </p>
        </div>
      ) : (
        <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {events.map((event) => (
            <EventRow key={`event${event.id}`} event={event} user={currentUser} attendingEventIds={attendingEventIds} />
          ))}
        </div>
      )}
    </section>

    <section className={SECTION_CLASS}>
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h2 className={H2_CLASS}>Past events</h2>
        <a
          href="/past-events"
          className="inline-flex items-center text-sm font-bold text-clcblue dark:text-clcnavy-light hover:text-clcnavy-dark transition-colors"
        >
          View past events →
        </a>
      </div>
      <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
        Missed something? Browse the archive of events you may have attended.
      </p>
    </section>
  </div>
}
